<template>
  <div id="app">
    <router-view />
    <LegalConsent />
  </div>
</template>

<script>
import LegalConsent from '@/components/LegalConsent.vue';

export default {
  name: 'App',
  components: {
    LegalConsent,
  },
};
</script>

<style>
  @font-face {
    font-family: 'RostelecomBasis';
    src: url('~@/assets/fonts/rostelecombasis_light.otf');
    font-style: normal;
    font-weight: normal;
  }

  body {
    margin: 0;
    font-family: 'RostelecomBasis';
  }

</style>
